/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import React, { Component } from "react";
import ContextMenuCss from "../contextMenu/css/ContextMenu.css";
import Button from "@react/react-spectrum/Button/js/Button";
import CopyIcon from "../../assets/s_copy_hud_18.svg";
import { injectIntl } from "react-intl";
import Tooltip from "@react/react-spectrum/Tooltip";
import OverlayTrigger from "@react/react-spectrum/OverlayTrigger";
import { FormattedMessage } from "react-intl";
import { trackCopyTextFromContextMenu } from "../../analytics/events";
import * as Constants from "constants/constants";

class CopyTextIcon extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    return (
      <FormattedMessage id="contextMenu.textSelectionEureka">
        {tooltip => (
          <OverlayTrigger
            trigger="hover"
            placement={Constants.TOOLTIP_TOP_PLACEMENT}
            delayShow={Constants.TOOLTIP_DELAY}
          >
            <div className={ContextMenuCss.icons} style={{ height: "inherit" }}>
              <Button
                variant="action"
                onClick={event => {
                  this.props.textManager.copyText();
                  trackCopyTextFromContextMenu();
                }}
                quiet
                tabindex="0"
                aria-label={this.props.intl.formatMessage({ id: "contextMenu.textSelectionEureka" })}
                icon={<CopyIcon />}
              />
            </div>
            <Tooltip>{tooltip}</Tooltip>
          </OverlayTrigger>
        )}
      </FormattedMessage>
    );
  }
}

export default injectIntl(CopyTextIcon);
